<h2>
  {{ translationService.getPlasticsDeclarationText() }}
</h2>

@if (plasticsDeclaration) {
  <mat-nav-list>
    <a mat-list-item>
      <span matListItemTitle>
        <span class="bold">{{ translationService.getMaterialTypeText() }}</span>
        {{ displayMaterialType(plasticsDeclaration.productMaterialType) }}
      </span>
    </a>
    <mat-divider></mat-divider>

    <!-- Raw Resin-only fields -->
    @if (isRawResin()) {
      <a mat-list-item>
        <span matListItemTitle>
          <span class="bold">{{ translationService.getNapcsCodeText() }}</span>
          {{ plasticsDeclaration.napcsCode }}
        </span>
      </a>
      <mat-divider></mat-divider>

      <a mat-list-item>
        <span matListItemTitle>
          <span class="bold">{{
            translationService.getProductWeightKgText()
          }}</span>
          {{ plasticsDeclaration.productWeightKg }}
        </span>
      </a>
      <mat-divider></mat-divider>

      <a mat-list-item>
        <span matListItemTitle>
          <span class="bold">{{ translationService.getSourceTypeText() }}</span>
          {{ plasticsDeclaration.sourceType }}
        </span>
      </a>
      <mat-divider></mat-divider>

      <a mat-list-item>
        <span matListItemTitle>
          <span class="bold">{{ translationService.getSupplierText() }}</span>
          {{ plasticsDeclaration.supplier }}
        </span>
      </a>
      <mat-divider></mat-divider>
    }

    <a mat-list-item>
      <span matListItemTitle>
        <span class="bold">{{ translationService.getWasteStreamText() }}</span>
        {{ formatWasteStreams(plasticsDeclaration) }}
      </span>
    </a>
    <mat-divider></mat-divider>

    <!-- Plastic Product-only fields -->
    @if (isPlasticProduct()) {
      <a mat-list-item>
        <span matListItemTitle>
          <span class="bold">{{ translationService.getCategoryText() }}</span>
          {{ plasticsDeclaration.category }}
        </span>
      </a>
      <mat-divider></mat-divider>

      <a mat-list-item>
        <span matListItemTitle>
          <span class="bold">{{
            translationService.getSubcategoryText()
          }}</span>
          {{ plasticsDeclaration.subcategory }}
        </span>
      </a>
      <mat-divider></mat-divider>
    }

    <!-- Shown for both Plastic Product and Raw Resin -->
    @if (!isNonPlastic()) {
      <a mat-list-item>
        <span matListItemTitle>
          <span class="bold">{{
            translationService.getReportingDateText()
          }}</span>
          {{ plasticsDeclaration.reportingDate }}
        </span>
      </a>
    }
  </mat-nav-list>
}
